import { useRouter } from 'next/router'
import { ErrorBoundary } from 'react-error-boundary'

import { RoleContentProvider } from 'app/KinerjaShared/components/RoleContentProvider'
import { ToggleSdkContext } from 'utils/useToogleSdk'
import KinerjaLayoutBase from 'app/KinerjaShared/components/KinerjaLayoutBase'
import { KinerjaErrorBoundary } from 'app/KinerjaShared/components/KinerjaErrorBoundary'
import PeriodProvider from 'app/KinerjaShared/components/PeriodProvider'

import type { KinerjaLayoutBase as KinerjaLayoutBaseProps } from 'types/kinerja-layout'
import type { KinerjaLayoutPage } from 'types/kinerja-layout'
import type { FallbackProps } from 'react-error-boundary'

export type PageProps = KinerjaLayoutPage
export type KinerjaLayoutProps = KinerjaLayoutBaseProps

const title = 'Pengelolaan Kinerja'

const KinerjaLayout = (props: KinerjaLayoutProps) => {
  const { asPath } = useRouter()

  return (
    <ErrorBoundary
      resetKeys={[asPath]}
      FallbackComponent={(errorProps: FallbackProps) => (
        <KinerjaErrorBoundary
          {...errorProps}
          layoutProps={{ title, ...props }}
        />
      )}
    >
      <ToggleSdkContext.Provider value={props?.pageProps?.toggle}>
        <RoleContentProvider
          disableLoading // Prevent loading spinner to take over the screen when loading the user profile
        >
          <PeriodProvider>
            <KinerjaLayoutBase title={title} {...props} />
          </PeriodProvider>
        </RoleContentProvider>
      </ToggleSdkContext.Provider>
    </ErrorBoundary>
  )
}

export default KinerjaLayout
